var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    clipPath: "url(#clip0_4998_5972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42456 0.674561C9.73824 0.674561 12.4246 3.36085 12.4246 6.67456V0.674561H18.4246C21.7382 0.674561 24.4246 3.36085 24.4246 6.67456C24.4246 9.98824 21.7382 12.6746 18.4246 12.6746C21.7382 12.6746 24.4246 15.3609 24.4246 18.6746C24.4246 20.3199 23.7622 21.8106 22.6897 22.8946L22.6672 22.9172L22.6473 22.937C21.5631 24.0111 20.0713 24.6746 18.4246 24.6746C16.789 24.6746 15.3063 24.0201 14.224 22.9589C14.2099 22.9451 14.1959 22.9311 14.1819 22.9172C14.1688 22.9041 14.1557 22.8909 14.1427 22.8776C13.08 21.7951 12.4246 20.3114 12.4246 18.6746C12.4246 21.9882 9.73824 24.6746 6.42456 24.6746C3.11085 24.6746 0.424561 21.9882 0.424561 18.6746V12.6746H6.42456C3.11085 12.6746 0.424561 9.98824 0.424561 6.67456C0.424561 3.36085 3.11085 0.674561 6.42456 0.674561ZM11.2246 6.67456C11.2246 9.32554 9.07554 11.4746 6.42456 11.4746V1.87456C9.07554 1.87456 11.2246 4.02359 11.2246 6.67456ZM23.2246 18.6746C23.2246 16.0236 21.0755 13.8746 18.4246 13.8746C15.7736 13.8746 13.6246 16.0236 13.6246 18.6746H23.2246ZM1.62456 13.8746V18.6746C1.62456 21.3255 3.77359 23.4746 6.42456 23.4746C9.07554 23.4746 11.2246 21.3255 11.2246 18.6746V13.8746H1.62456ZM13.6246 11.4746V1.87456H18.4246C21.0755 1.87456 23.2246 4.02359 23.2246 6.67456C23.2246 9.32554 21.0755 11.4746 18.4246 11.4746H13.6246Z",
    fill: "#5417D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4998_5972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.424561 0.674561)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.f02ad58898606145ea2dc502195a1d8c.svg";
export { ForwardRef as ReactComponent };